import { logCopilotChatSidePaneTelemetryEvent } from 'owa-copilot-telemetry/lib/copilotChatSidePaneTelemetryLogger';
import { setUserPreferredWidthMutator } from '../mutators/setUserPreferredWidthMutator';
import { onCopilotChatDrawerLayoutChange } from '../actions/onCopilotChatDrawerLayoutChange';

/**
 * Function to handle the click-and-drag resizing of the Copilot Chat Drawer.
 * @param newWidth The new width of the Copilot Chat Drawer.
 */
export function resizeCopilotChatDrawer(targetWindow: Window, newWidth: number): void {
    setUserPreferredWidthMutator(targetWindow, newWidth);
    logCopilotChatSidePaneTelemetryEvent('CopilotSidePane_UserResized');
    if (targetWindow === window) {
        onCopilotChatDrawerLayoutChange();
    }
}
